"use strict";

var React = require('react');
var Helpers = require('../mixins/Helpers');
var directScroller = require('../mixins/direct-scroller');

var DirectLink = React.createClass({
  render: function () {
    return React.DOM.a(this.props, this.props.children);
  }
});

module.exports = Helpers.Scroll(DirectLink, directScroller);



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-scroll/lib/components/DirectLink.js
 ** module id = 490
 ** module chunks = 0
 **/